import React, { useState, useMemo } from 'react'
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

const OrdersVsDispatch = ({ resPacket }) => {
    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    // Group items by invoiceNumber
    const groupedInvoices = useMemo(() => {
        if (!resPacket) return [];
        const map = new Map();
        resPacket.forEach(order => {
            const key = order.invoiceNumber;
            if (!map.has(key)) {
                map.set(key, {
                    invoiceDate: order.invoiceDate,
                    invoiceNumber: order.invoiceNumber,
                    salesDate: order.salesDate,
                    salesNumber: order.salesNumber,
                    customerName: order.customerName,
                    items: []
                });
            }
            map.get(key).items.push(order);
        });
        return Array.from(map.values());
    }, [resPacket]);

    const handleInvoiceClick = (invoice) => {
        setSelectedInvoice(invoice);
        setIsModalOpen(true);
    };

    return (
        <div className="customTable" id="scroll">
            <table className="customTable w-100">
                <thead className="fixed-thead">
                    <tr>
                        <td>Invoice Date</td>
                        <td>Invoice No.</td>
                        <td>Sales Date</td>
                        <td>Sales No.</td>
                        <td>Customer Name</td>
                    </tr>
                </thead>
                <tbody className="body-scroll-custom">
                    {
                        groupedInvoices.map((invoice, index) => (
                            <tr key={index} onClick={() => handleInvoiceClick(invoice)} style={{ cursor: 'pointer' }}>
                                <td>{invoice.invoiceDate}</td>
                                <td style={{ color: '#1890ff', textDecoration: 'underline' }}>{invoice.invoiceNumber}</td>
                                <td>{invoice.salesDate}</td>
                                <td>{invoice.salesNumber}</td>
                                <td>{invoice.customerName}</td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>

            <Modal
                show={isModalOpen}
                onHide={() => setIsModalOpen(false)}
                size="xl"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        {selectedInvoice?.invoiceNumber} - {selectedInvoice?.customerName}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <table className="customTable w-100">
                        <thead>
                            <tr>
                                <td>Item Name</td>
                                <td>UOM</td>
                                <td>Order Qty</td>
                                <td>Dispatch Qty</td>
                                <td>Category</td>
                                <td>Sub Category</td>
                                <td>Variance</td>
                            </tr>
                        </thead>
                        <tbody>
                            {selectedInvoice?.items
                                .filter((item) => Number(item.variance) !== 0)
                                .map((item, idx) => (
                                <tr key={idx}>
                                    <td>{item.itemName}</td>
                                    <td>{item.uom}</td>
                                    <td>{item.orderQty}</td>
                                    <td>{item.dispatchQty}</td>
                                    <td>{item.categoryTitle}</td>
                                    <td>{item.subCategoryTitle}</td>
                                    <td>{item.variance}</td>
                                </tr>
                            ))}
                            {selectedInvoice?.items.filter((item) => Number(item.variance) !== 0).length === 0 && (
                                <tr>
                                    <td colSpan={7} style={{ textAlign: "center" }}>No variance found</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={() => setIsModalOpen(false)}>Close</Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default OrdersVsDispatch
